import React, { useState } from "react";
import "./ContactForm.css";
import emailjs from "@emailjs/browser";
import { FiSend, FiCheckCircle } from "react-icons/fi";
import { useTranslation } from "react-i18next";

function ContactForm() {
  const { t } = useTranslation();

  // --- ETATS ---
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState(""); // '', 'sending', 'success', 'error'

  // --- LOGIQUE ---
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");
    emailjs
      .send(
        "service_wcpsarx",
        "template_0hsxxe9",
        formData,
        "wiuDluGgV01OUC3tB",
      )
      .then(
        (result) => {
          setStatus("success");
          setFormData({ nom: "", prenom: "", email: "", message: "" });
        },
        (error) => {
          console.log(error.text);
          setStatus("error");
          alert(t("contact.error_alert"));
        },
      );
  };

  // --- RENDU ---
  return (
    <div className="contact-form-container glass-panel">
      <div className="form-header">
        <h2>{t("contact.title")}</h2>
        <p className="gradient-text">{t("contact.subtitle")}</p>
      </div>

      {status === "success" ? (
        <div className="success-message">
          <FiCheckCircle className="success-icon" />
          <h3>{t("contact.success_title")}</h3>
          <p>{t("contact.success_text")}</p>
          <button onClick={() => setStatus("")} className="reset-btn">
            {t("contact.btn_reset")}
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="glass-form">
          <div className="form-row">
            <div className="input-group">
              <label>{t("contact.label_name")}</label>
              <input
                type="text"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                required
                placeholder={t("contact.placeholder_name")}
              />
            </div>

            <div className="input-group">
              <label>{t("contact.label_firstname")}</label>
              <input
                type="text"
                name="prenom"
                value={formData.prenom}
                onChange={handleChange}
                required
                placeholder={t("contact.placeholder_firstname")}
              />
            </div>
          </div>

          <div className="input-group">
            <label>{t("contact.label_email")}</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder={t("contact.placeholder_email")}
            />
          </div>

          <div className="input-group">
            <label>{t("contact.label_message")}</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder={t("contact.placeholder_message")}
              rows="5"
            ></textarea>
          </div>

          <button
            type="submit"
            className="submit-btn"
            disabled={status === "sending"}
          >
            {status === "sending"
              ? t("contact.btn_sending")
              : t("contact.btn_send")}
            {status !== "sending" && <FiSend />}
          </button>
        </form>
      )}
    </div>
  );
}

export default ContactForm;
